import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery, IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {DokumentRessurs} from "felles/tjenester/ressurser/DokumentRessurs";
import {Debugger} from "debug";
import {Filer} from "../../../felles/tjenester/Filer";
import {uriEnkodet} from "../../../felles/stoettefunk/uri";

const css = require('./inlinePdfjsVisning.scss');
const debug: Debugger = require('debug')('InlinePdfjsVisning');

/**
 * viser angitt pdf dokument versjon i en iframe vhja pdfjs
 */
export class InlinePdfVisning implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkInlineIframePdfVisning', {
                bindings: {
                    dokumentversjon: '<',
                    forespurtAnnoteringId: '<'
                },
                controller: InlinePdfVisning.forInjisering(),
                template: require('./inlinePdfVisning.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [regNavn.ng.$scope, regNavn.ng.$element, DokumentRessurs.regNavn, InlinePdfVisning]
    }

    constructor(private $scope: IScope, private $element: IAugmentedJQuery, private dokumentRessurs: DokumentRessurs) {
    }

    dokumentversjon: l.DokumentVersjonModell; //settes via bindings
    forespurtAnnoteringId: string; //settes via bindings

    url: string;

    $onChanges(endringer: IOnChangesObject): void {
        if (changesInneholder(endringer, 'dokumentversjon'))
            this.initUrl();
    }

    stotterPdfJs() {
        return this.dokumentRessurs.støtterPdfjs();
    }
    
    //hjelpemetoder

    private initUrl() {
        this.url = this.dokumentRessurs.dokumentUrl(this.dokumentversjon.id, Filer.mimetyper.pdf.mimetype, uriEnkodet(this.dokumentversjon.pdfFilnavn));
        debug('åpner som inline pdf i nettlesers iframe', this.url);
    }

}
